/**
 * This is placeholder for JDRF Gutenberg Video Card Modal.
 *
 * @link https://jdrf.atlassian.net/browse/RSMS-19
 *
 * @see JDRFGutenberg\Core\load_video_cards_modal() in "wp-content/plugins/jdrf-gutenberg/includes/functions/core.php".
 */
import A11yDialog from 'a11y-dialog';

const init = () => {

	/**
	 * Define global TenUp object if it doesn't exist
	 */
	if ( 'object' !== typeof window.A11yDialog ) {
		window.A11yDialog = {};
	}

	const el = document.getElementById( 'jdrf-modal' );

	/**
	 * Return if modal does not exist
	 */
	if ( ! el ) {
		return;
	}

	const main = document.getElementById( 'spirit-shell-main' );
	const cards = Array.prototype.slice.call( document.querySelectorAll( '.spirit-card-video' ) );
	const modal = document.querySelector( '.jdrf-modal__scroll-container' );
	const dialog = new A11yDialog( el, main );

	/**
	 * dynamically update aria-labelledby
	 * @param id Element id.
	 */
	function updateAriaLabelBy( id ) {
		if ( id ) {
			const dialogTitleID = `${id}-title`;
			const dialogTitle = document.getElementById( dialogTitleID );

			if( dialogTitle ) {
				modal.setAttribute( 'aria-labelledby', dialogTitleID );
			}
		} else {
			modal.setAttribute( 'aria-labelledby', '' );
		}
	}

	/**
	 * open correct modal if window url contains a hash
	 */
	window.addEventListener( 'load', function () {
		if ( window.location.hash && window.location.hash.length ) {
			const hash = decodeURIComponent( window.location.hash.substr( 1 ) );
			const activeModal = document.getElementById( hash );

			if ( activeModal ) {
				updateAriaLabelBy( hash );
				dialog.show();
				activeModal.classList.add( 'jdrf-modal-item--active' );
				document.documentElement.classList.add( 'jdrf-modal-open' );
				el.setAttribute( 'aria-hidden', false );
			}
		}
		cards.forEach( ( card ) => {
			card.addEventListener( 'click', function( e ) {
				openModal( e );
			} );
		} );
	}, false );

	/**
	 * open ally-dialog
	 * @param e The JS click event.
	 */
	function openModal( e ) {
		e.preventDefault();

		const idRef = e.target.dataset.card_id;
		const activeModalItem = document.getElementById( idRef );
		activeModalItem.classList.add( 'jdrf-modal-item--active' );
		// update the arialableby value
		updateAriaLabelBy( idRef );
		dialog.show();
		el.setAttribute( 'aria-hidden', false );
		document.documentElement.classList.add( 'jdrf-modal-open' );

		// update window state in case user uses it to share
		window.history.pushState( {}, null, `#${ idRef }` );
	}

	dialog.on( 'hide', function () {
		let windowLocation = window.location.href;
		document.documentElement.classList.remove( 'jdrf-modal-open' );
		const modalItem = document.querySelector( '.jdrf-modal-item--active' );
		const iframe = document.querySelector( '.jdrf-modal-item--active iframe' );
		// matches the watch and updates to embed for youtube embeds
		const youtubeRegex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/;
		const match = iframe.src.match( youtubeRegex );

		// update embed src to prevent 'X-Frame-Options' to 'sameorigin' error
		if ( match && 11 === match[ 2 ].length  ) {
			iframe.src = match[ 0 ];
		} else {
			iframe.src = iframe.src;
		}
		modalItem.classList.remove( 'jdrf-modal-item--active' );
		el.setAttribute( 'aria-hidden', true );

		// reset arialabellby to black
		updateAriaLabelBy();

		// revert url back to original state
		window.history.pushState( {}, null, windowLocation.replace( `#${ modalItem.id }`, '' )  );
	} );
};

export default { init };
